module.exports = __webpack_public_path__ + "img/center back length to hem.cd5373f6.png";